import { Room } from '@/types/room';

export const rooms: Room[] = [
  // FREE ROOMS
  {
    id: 'how-many-times-left',
    title: 'How Many Times Left',
    subtitle: 'A count of what remains',
    isPremium: false,
    category: 'mortality',
    path: '/room/how-many-times-left',
  },
  {
    id: 'life-in-weeks',
    title: 'Your Life in Weeks',
    subtitle: "4,000 squares. That's all.",
    isPremium: false,
    category: 'time',
    path: '/room/life-in-weeks',
  },
  {
    id: 'delay-button',
    title: 'The Delay Button',
    subtitle: 'It gets harder every time',
    isPremium: false,
    category: 'truth',
    path: '/room/delay-button',
  },
  {
    id: 'one-honest-sentence',
    title: 'One Honest Sentence',
    subtitle: 'No edits. No delete.',
    isPremium: false,
    category: 'identity',
    path: '/room/one-honest-sentence',
  },
  {
    id: 'this-moment',
    title: 'This Moment Will Never Happen Again',
    subtitle: 'You are here. Once.',
    isPremium: false,
    category: 'time',
    path: '/room/this-moment',
  },
  {
    id: 'reality-receipt',
    title: 'Reality Receipt',
    subtitle: 'A summary of your days',
    isPremium: false,
    category: 'truth',
    path: '/room/reality-receipt',
  },
  {
    id: 'nothing-happens',
    title: 'Nothing Happens Here',
    subtitle: 'Exactly what it says',
    isPremium: false,
    category: 'nothing',
    path: '/room/nothing-happens',
  },
  // TEXT/INTERACTION ROOMS - FREE
  {
    id: 'default-choice',
    title: 'Your Default Choice',
    subtitle: 'Safety or risk. Every time.',
    isPremium: false,
    category: 'truth',
    path: '/room/default-choice',
  },
  {
    id: 'thought-loop',
    title: 'The Thought Loop',
    subtitle: 'Watch your mind repeat itself',
    isPremium: false,
    category: 'identity',
    path: '/room/thought-loop',
  },
  {
    id: 'expect-vs-happens',
    title: 'What You Expect vs What Happens',
    subtitle: 'The gap between hope and reality',
    isPremium: false,
    category: 'truth',
    path: '/room/expect-vs-happens',
  },
  {
    id: 'question-never-answer',
    title: 'The Question You Never Answer',
    subtitle: 'Most users leave',
    isPremium: false,
    category: 'identity',
    path: '/room/question-never-answer',
  },
  {
    id: 'not-special',
    title: "You're Not Special (And That's Okay)",
    subtitle: 'No comfort. Just truth.',
    isPremium: false,
    category: 'truth',
    path: '/room/not-special',
  },
  {
    id: 'shortcut-always-take',
    title: 'The Shortcut You Always Take',
    subtitle: 'Patterns reveal themselves',
    isPremium: false,
    category: 'truth',
    path: '/room/shortcut-always-take',
  },
  // IMAGE/VISUAL ROOMS - FREE
  {
    id: 'blurred-self',
    title: 'Blurred Self',
    subtitle: 'Memory works like this',
    isPremium: false,
    category: 'identity',
    path: '/room/blurred-self',
  },
  {
    id: 'image-zooming',
    title: 'The Image You Keep Zooming',
    subtitle: 'Seeking answers in nothing',
    isPremium: false,
    category: 'truth',
    path: '/room/image-zooming',
  },
  {
    id: 'comfort-color',
    title: 'The Comfort Color',
    subtitle: 'How long will you stay?',
    isPremium: false,
    category: 'nothing',
    path: '/room/comfort-color',
  },
  {
    id: 'line-you-crossed',
    title: 'The Line You Crossed',
    subtitle: 'We see where you hesitated',
    isPremium: false,
    category: 'truth',
    path: '/room/line-you-crossed',
  },
  // VOICE ROOMS - FREE
  {
    id: 'read-aloud',
    title: 'Read This Aloud',
    subtitle: 'Words you must speak',
    isPremium: false,
    category: 'truth',
    path: '/room/read-aloud',
  },
  {
    id: 'voice-without-meaning',
    title: 'Your Voice Without Meaning',
    subtitle: 'Sound without words',
    isPremium: false,
    category: 'identity',
    path: '/room/voice-without-meaning',
  },

  // DEEP ROOMS (formerly premium - now free)
  {
    id: 'sentence-you-avoid',
    title: 'The Sentence You Avoid',
    subtitle: 'You cannot leave until you write it',
    isPremium: false,
    category: 'truth',
    path: '/room/sentence-you-avoid',
  },
  {
    id: 'if-nothing-changes',
    title: 'If Nothing Changes',
    subtitle: 'A projection of your next five years',
    isPremium: false,
    category: 'mortality',
    path: '/room/if-nothing-changes',
  },
  {
    id: 'real-priorities',
    title: 'Your Real Priorities',
    subtitle: 'Based on time, not words',
    isPremium: false,
    category: 'truth',
    path: '/room/real-priorities',
  },
  {
    id: 'last-conversation',
    title: 'The Last Conversation',
    subtitle: 'Write what you will never send',
    isPremium: false,
    category: 'identity',
    path: '/room/last-conversation',
  },
  {
    id: 'who-without-job',
    title: 'Who Are You Without Your Job?',
    subtitle: 'Rewrite yourself',
    isPremium: false,
    category: 'identity',
    path: '/room/who-without-job',
  },
  {
    id: 'comfort-zone-scanner',
    title: 'Comfort Zone Scanner',
    subtitle: 'We see your hesitation',
    isPremium: false,
    category: 'truth',
    path: '/room/comfort-zone-scanner',
  },
  {
    id: 'say-it-once',
    title: 'Say It Once',
    subtitle: 'No replay. No redo.',
    isPremium: false,
    category: 'truth',
    path: '/room/say-it-once',
  },
  {
    id: 'listen-to-yourself',
    title: 'Listen to Yourself',
    subtitle: 'Your voice, slowed down',
    isPremium: false,
    category: 'identity',
    path: '/room/listen-to-yourself',
  },
  {
    id: 'life-as-shapes',
    title: 'Your Life as Shapes',
    subtitle: 'Abstract. Unlabeled. Yours.',
    isPremium: false,
    category: 'identity',
    path: '/room/life-as-shapes',
  },
  {
    id: 'face-without-features',
    title: 'Face Without Features',
    subtitle: 'Remove until nothing remains',
    isPremium: false,
    category: 'identity',
    path: '/room/face-without-features',
  },
  // NIGHT ROOMS (now free)
  {
    id: 'what-keeps-awake',
    title: 'What Keeps You Awake',
    subtitle: 'Available after 10 PM',
    isPremium: false,
    category: 'night',
    path: '/room/what-keeps-awake',
  },
  {
    id: 'you-at-317am',
    title: 'You at 3:17 AM',
    subtitle: 'Time-specific. Personal.',
    isPremium: false,
    category: 'night',
    path: '/room/you-at-317am',
  },
  {
    id: 'thought-that-returns',
    title: 'The Thought That Returns',
    subtitle: 'It comes back every visit',
    isPremium: false,
    category: 'night',
    path: '/room/thought-that-returns',
  },
  // META ROOMS
  {
    id: 'room-you-visit-most',
    title: 'The Room You Visit Most',
    subtitle: 'Your pattern revealed',
    isPremium: false,
    category: 'meta',
    path: '/room/room-you-visit-most',
  },
  {
    id: 'room-you-avoid',
    title: 'The Room You Avoid',
    subtitle: 'What you skip says something',
    isPremium: false,
    category: 'meta',
    path: '/room/room-you-avoid',
  },
  {
    id: 'left-too-early',
    title: 'You Left Too Early',
    subtitle: 'Triggered when you exit fast',
    isPremium: false,
    category: 'meta',
    path: '/room/left-too-early',
  },
  // DAILY ROOMS
  {
    id: 'daily-quote',
    title: 'Quote of the Day',
    subtitle: 'Wisdom that changes daily',
    isPremium: false,
    category: 'daily',
    path: '/room/daily-quote',
  },
  {
    id: 'daily-joke',
    title: 'Joke of the Day',
    subtitle: 'Dark humor, updated daily',
    isPremium: false,
    category: 'daily',
    path: '/room/daily-joke',
  },
  {
    id: 'imagine-yourself',
    title: 'Imagine Yourself',
    subtitle: 'Describe yourself. See what emerges.',
    isPremium: false,
    category: 'experimental',
    path: '/room/imagine-yourself',
  },
  {
    id: 'dream-visualization',
    title: 'Dream Visualization',
    subtitle: 'Describe a dream. Watch it materialize.',
    isPremium: false,
    category: 'experimental',
    path: '/room/dream-visualization',
  },
  {
    id: 'future-self',
    title: 'Future Self',
    subtitle: 'Who do you want to become?',
    isPremium: false,
    category: 'experimental',
    path: '/room/future-self',
  },
   {
     id: 'regret-machine',
     title: 'The Regret Machine',
     subtitle: 'Explore what might have been',
     isPremium: false,
     category: 'experimental',
     path: '/room/regret-machine',
   },
   {
     id: 'memory-reconstruction',
     title: 'Memory Reconstruction',
     subtitle: 'Rebuild a fading memory',
     isPremium: false,
     category: 'experimental',
     path: '/room/memory-reconstruction',
   },
  // SCARY ROOMS (Hidden until unlocked)
  {
    id: 'theyre-watching',
    title: "They're Watching",
    subtitle: 'You are not alone',
    isPremium: false,
    category: 'scary',
    path: '/room/theyre-watching',
  },
  {
    id: 'the-last-visitor',
    title: 'The Last Visitor',
    subtitle: 'Someone was here before you',
    isPremium: false,
    category: 'scary',
    path: '/room/the-last-visitor',
  },
  {
    id: 'dont-look-away',
    title: "Don't Look Away",
    subtitle: 'It knows when you leave',
    isPremium: false,
    category: 'scary',
    path: '/room/dont-look-away',
  },
  {
    id: 'the-whisper',
    title: 'The Whisper',
    subtitle: 'Listen closely',
    isPremium: false,
    category: 'scary',
    path: '/room/the-whisper',
  },
  {
    id: 'you-forgot-something',
    title: 'You Forgot Something',
    subtitle: 'What was it?',
    isPremium: false,
    category: 'scary',
    path: '/room/you-forgot-something',
  },
  {
    id: 'the-mirror-lies',
    title: 'The Mirror Lies',
    subtitle: 'Crack it to see the truth',
    isPremium: false,
    category: 'scary',
    path: '/room/the-mirror-lies',
  },
  {
    id: 'something-follows',
    title: 'Something Follows',
    subtitle: 'Keep running',
    isPremium: false,
    category: 'scary',
    path: '/room/something-follows',
  },
  {
    id: 'the-countdown',
    title: 'The Countdown',
    subtitle: 'Something happens at zero',
    isPremium: false,
    category: 'scary',
    path: '/room/the-countdown',
  },
  {
    id: 'eyes-in-the-dark',
    title: 'Eyes in the Dark',
    subtitle: 'They multiply',
    isPremium: false,
    category: 'scary',
    path: '/room/eyes-in-the-dark',
  },
  {
    id: 'the-voice',
    title: 'The Voice',
    subtitle: 'Someone is trapped here',
    isPremium: false,
    category: 'scary',
    path: '/room/the-voice',
  },
  {
    id: 'it-knows-your-name',
    title: 'It Knows Your Name',
    subtitle: 'You should not have come',
    isPremium: false,
    category: 'scary',
    path: '/room/it-knows-your-name',
  },
  {
    id: 'the-door',
    title: 'The Door',
    subtitle: 'Something is knocking',
    isPremium: false,
    category: 'scary',
    path: '/room/the-door',
  },
  // BOSS ROOMS
  {
    id: 'boss-room-free',
    title: 'The Sum of Your Truths',
    subtitle: 'The final free room',
    isPremium: false,
    category: 'truth',
    path: '/room/boss-room-free',
  },
  {
    id: 'boss-room-horror',
    title: 'The Heart of Fear',
    subtitle: 'Face the final darkness',
    isPremium: false,
    category: 'scary',
    path: '/room/boss-room-horror',
  },
  // BEHAVIORAL ROOMS
  {
    id: 'mouse-tracker',
    title: 'The Mouse Tracker',
    subtitle: 'We see how you move',
    isPremium: false,
    category: 'meta',
    path: '/room/mouse-tracker',
  },
  {
    id: 'scroll-confession',
    title: 'Scroll Confession',
    subtitle: 'How fast do you rush?',
    isPremium: false,
    category: 'truth',
    path: '/room/scroll-confession',
  },
  {
    id: 'waiting-game',
    title: 'The Waiting Game',
    subtitle: 'Can you do nothing?',
    isPremium: false,
    category: 'nothing',
    path: '/room/waiting-game',
  },
  {
    id: 'day-in-pixels',
    title: 'Your Day in Pixels',
    subtitle: 'Time becomes shape',
    isPremium: false,
    category: 'time',
    path: '/room/day-in-pixels',
  },
  // PUZZLE ROOMS
  {
    id: 'memory-maze',
    title: 'Memory Maze',
    subtitle: 'The pattern changes',
    isPremium: false,
    category: 'identity',
    path: '/room/memory-maze',
  },
  {
    id: 'decision-shadow',
    title: 'Decision Shadow',
    subtitle: 'Your choices reveal patterns',
    isPremium: false,
    category: 'truth',
    path: '/room/decision-shadow',
  },
  // SOCIAL REFLECTION
  {
    id: 'anonymous-mirrors',
    title: 'Anonymous Mirrors',
    subtitle: 'Thoughts from strangers',
    isPremium: false,
    category: 'identity',
    path: '/room/anonymous-mirrors',
  },
  {
    id: 'collective-room',
    title: 'The Collective Room',
    subtitle: 'Everyone is here. No one stays.',
    isPremium: false,
    category: 'nothing',
    path: '/room/collective-room',
  },
  // SECRET ROOMS
  {
    id: 'secret-room',
    title: 'The Secret Room',
    subtitle: 'You found it',
    isPremium: false,
    category: 'meta',
    path: '/room/secret-room',
  },
  {
    id: 'glitch-room',
    title: 'Unstable Room',
    subtitle: 'Something is wrong',
    isPremium: false,
    category: 'scary',
    path: '/room/glitch-room',
  },
  // TIME-LOCKED ROOMS
  {
    id: 'full-moon-room',
    title: 'Full Moon Room',
    subtitle: 'Only opens during lunar peak',
    isPremium: false,
    category: 'night',
    path: '/room/full-moon-room',
  },
  {
    id: 'weekend-room',
    title: 'Weekend Room',
    subtitle: 'Rest is a destination',
    isPremium: false,
    category: 'time',
    path: '/room/weekend-room',
  },
  {
    id: '317am-room',
    title: '3:17 AM Room',
    subtitle: 'Time-specific. Personal.',
    isPremium: false,
    category: 'night',
    path: '/room/317am-room',
  },
  // SECRET DISCOVERY ROOMS
  {
    id: 'idle-room',
    title: 'The Still Room',
    subtitle: 'Found through patience',
    isPremium: false,
    category: 'nothing',
    path: '/room/idle-room',
  },
  // SOCIAL ROOM
  {
    id: 'invite-friend-room',
    title: 'The Shared Room',
    subtitle: 'Some journeys are meant to be witnessed',
    isPremium: false,
    category: 'identity',
    path: '/room/invite-friend-room',
  },
  // SEASONAL ROOMS
  {
    id: 'halloween-room',
    title: 'The Veil Room',
    subtitle: 'October 31st - The veil is thin',
    isPremium: false,
    category: 'scary',
    path: '/room/halloween-room',
  },
  {
    id: 'winter-solstice-room',
    title: 'The Longest Night',
    subtitle: 'December 21st - Release and keep',
    isPremium: false,
    category: 'night',
    path: '/room/winter-solstice-room',
  },
  {
    id: 'new-year-room',
    title: 'Letter to Future Self',
    subtitle: 'December 31st - Write to who you will be',
    isPremium: false,
    category: 'time',
    path: '/room/new-year-room',
  },
  // DEEP BOSS ROOM (formerly premium - now free)
  {
    id: 'boss-room-premium',
    title: 'The Deepest Truth',
    subtitle: 'The final deep room',
    isPremium: false,
    category: 'truth',
    path: '/room/boss-room-premium',
  },
  // ENGAGEMENT & DEPTH ROOMS
  {
    id: 'time-capsule',
    title: 'Time Capsule',
    subtitle: 'Write to your future self',
    isPremium: false,
    category: 'time',
    path: '/room/time-capsule',
  },
  {
    id: 'the-revisit',
    title: 'The Revisit',
    subtitle: 'See how your answers changed',
    isPremium: false,
    category: 'meta',
    path: '/room/the-revisit',
  },
  {
    id: 'contradiction-room',
    title: 'The Contradiction Room',
    subtitle: 'Your truths disagree',
    isPremium: false,
    category: 'meta',
    path: '/room/contradiction-room',
  },
  {
    id: 'export-journey',
    title: 'Export Your Journey',
    subtitle: 'Download your path',
    isPremium: false,
    category: 'meta',
    path: '/room/export-journey',
  },
  // SOCIAL ROOMS
  {
    id: 'anonymous-echoes',
    title: 'Anonymous Echoes',
    subtitle: 'Fragments from strangers',
    isPremium: false,
    category: 'identity',
    path: '/room/anonymous-echoes',
  },
  {
    id: 'the-waiting-room',
    title: 'The Waiting Room',
    subtitle: 'Unlock with presence',
    isPremium: false,
    category: 'nothing',
    path: '/room/the-waiting-room',
  },
  // EASTER EGG ROOMS (Hidden - discovered through secrets)
  {
    id: 'void-room',
    title: 'The Void',
    subtitle: 'A wound in the code',
    isPremium: false,
    category: 'secret',
    path: '/room/void-room',
  },
  {
    id: 'pattern-room',
    title: 'Your Patterns',
    subtitle: 'What the site sees in you',
    isPremium: false,
    category: 'secret',
    path: '/room/pattern-room',
  },
  // AI ROOMS
  {
    id: 'ai-reflection-room',
    title: 'The Reflection Room',
    subtitle: 'The mirror speaks back',
    isPremium: false,
    category: 'identity',
    path: '/room/ai-reflection-room',
  },
  // GAME ROOMS
  {
    id: 'memory-puzzle',
    title: 'Memory Puzzle',
    subtitle: 'Match patterns that subtly shift',
    isPremium: false,
    category: 'games',
    path: '/room/memory-puzzle',
  },
  {
    id: 'shadow-chase',
    title: 'Shadow Chase',
    subtitle: 'Catch what moves unpredictably',
    isPremium: false,
    category: 'games',
    path: '/room/shadow-chase',
  },
  {
    id: 'timing-room',
    title: 'Timing Room',
    subtitle: 'Click exactly in the moment',
    isPremium: false,
    category: 'games',
    path: '/room/timing-room',
  },
  {
    id: 'pattern-whisper',
    title: 'Pattern Whisper',
    subtitle: 'Repeat the fading sequence',
    isPremium: false,
    category: 'games',
    path: '/room/pattern-whisper',
  },
  {
    id: 'silence-puzzle',
    title: 'Silence Puzzle',
    subtitle: 'Solve without instructions',
    isPremium: false,
    category: 'games',
    path: '/room/silence-puzzle',
  },
  {
    id: 'decay-game',
    title: 'Decay Game',
    subtitle: 'Touch to preserve fading things',
    isPremium: false,
    category: 'games',
    path: '/room/decay-game',
  },
  {
    id: 'observation-test',
    title: 'Observation Test',
    subtitle: 'Find subtle differences',
    isPremium: false,
    category: 'games',
    path: '/room/observation-test',
  },
  {
    id: 'balance-room',
    title: 'Balance Room',
    subtitle: 'Keep floating objects aligned',
    isPremium: false,
    category: 'games',
    path: '/room/balance-room',
  },
  {
    id: 'word-drift',
    title: 'Word Drift',
    subtitle: 'Catch letters before they fall',
    isPremium: false,
    category: 'games',
    path: '/room/word-drift',
  },
  {
    id: 'color-echo',
    title: 'Color Echo',
    subtitle: 'Repeat the subtle tone sequence',
    isPremium: false,
    category: 'games',
    path: '/room/color-echo',
  },
  {
    id: 'mirror-tap',
    title: 'Mirror Tap',
    subtitle: 'Every tap echoes elsewhere',
    isPremium: false,
    category: 'games',
    path: '/room/mirror-tap',
  },
  {
    id: 'maze-of-doors',
    title: 'Maze of Doors',
    subtitle: 'Doors rearrange after each choice',
    isPremium: false,
    category: 'games',
    path: '/room/maze-of-doors',
  },
  {
    id: 'pulse-match',
    title: 'Pulse Match',
    subtitle: 'Move in rhythm with the room',
    isPremium: false,
    category: 'games',
    path: '/room/pulse-match',
  },
  {
    id: 'light-path',
    title: 'Light Path',
    subtitle: 'Guide light through shifting darkness',
    isPremium: false,
    category: 'games',
    path: '/room/light-path',
  },
  {
    id: 'sound-match',
    title: 'Sound Match',
    subtitle: 'Tap shapes to match soft tones',
    isPremium: false,
    category: 'games',
    path: '/room/sound-match',
  },
  // EXPERIMENTAL ROOMS
  {
    id: 'mirror-room',
    title: 'Mirror Room',
    subtitle: 'Reflections slightly distorted',
    isPremium: false,
    category: 'experimental',
    path: '/room/mirror-room',
  },
  {
    id: 'echo-room',
    title: 'Echo Room',
    subtitle: 'Clicks trigger delayed echoes',
    isPremium: false,
    category: 'experimental',
    path: '/room/echo-room',
  },
  {
    id: 'pulse-room',
    title: 'Pulse Room',
    subtitle: 'The environment breathes',
    isPremium: false,
    category: 'experimental',
    path: '/room/pulse-room',
  },
  {
    id: 'vanishing-room',
    title: 'Vanishing Room',
    subtitle: 'Elements fade as you interact',
    isPremium: false,
    category: 'experimental',
    path: '/room/vanishing-room',
  },
  {
    id: 'letter-room',
    title: 'Letter Room',
    subtitle: 'Words scramble like failing memory',
    isPremium: false,
    category: 'experimental',
    path: '/room/letter-room',
  },
  {
    id: 'empty-room',
    title: 'Empty Room',
    subtitle: 'Blank until you find secrets',
    isPremium: false,
    category: 'experimental',
    path: '/room/empty-room',
  },
  {
    id: 'reverse-room',
    title: 'Reverse Room',
    subtitle: 'Actions behave opposite',
    isPremium: false,
    category: 'experimental',
    path: '/room/reverse-room',
  },
  {
    id: 'whisper-room',
    title: 'Whisper Room',
    subtitle: 'Hints appear when you are still',
    isPremium: false,
    category: 'experimental',
    path: '/room/whisper-room',
  },
  {
    id: 'shadow-room',
    title: 'Shadow Room',
    subtitle: 'Things move just out of sight',
    isPremium: false,
    category: 'experimental',
    path: '/room/shadow-room',
  },
  {
    id: 'labyrinth-room',
    title: 'Labyrinth Room',
    subtitle: 'Hallways loop unpredictably',
    isPremium: false,
    category: 'experimental',
    path: '/room/labyrinth-room',
  },
  {
    id: 'color-room',
    title: 'Color Room',
    subtitle: 'Grayscale tones shift slowly',
    isPremium: false,
    category: 'experimental',
    path: '/room/color-room',
  },
  {
    id: 'surrender-room',
    title: 'Surrender Room',
    subtitle: 'Too much action hides the exit',
    isPremium: false,
    category: 'experimental',
    path: '/room/surrender-room',
  },
  {
    id: 'noise-room',
    title: 'Noise Room',
    subtitle: 'Move too fast and reality glitches',
    isPremium: false,
    category: 'experimental',
    path: '/room/noise-room',
  },
  {
    id: 'observer-room',
    title: 'Observer Room',
    subtitle: 'You feel watched',
    isPremium: false,
    category: 'experimental',
    path: '/room/observer-room',
  },
  // Theme-Exclusive Rooms
  {
    id: 'ash-embers',
    title: 'Ash & Embers',
    subtitle: 'Only visible in Ash theme',
    isPremium: false,
    category: 'experimental',
    path: '/room/ash-embers',
  },
  {
    id: 'twilight-stars',
    title: 'Twilight Stars',
    subtitle: 'Only visible in Twilight theme',
    isPremium: false,
    category: 'experimental',
    path: '/room/twilight-stars',
  },
  {
    id: 'void-abyss',
    title: 'The Abyss',
    subtitle: 'Only visible in Void theme',
    isPremium: false,
    category: 'experimental',
    path: '/room/void-abyss',
  },
  // ALTERNATE MODE EXCLUSIVE ROOMS
  {
    id: 'the-other-side',
    title: 'The Other Side',
    subtitle: 'move slowly through the dark',
    isPremium: false,
    category: 'alternate',
    path: '/room/the-other-side',
  },
  {
    id: 'the-unraveling',
    title: 'The Unraveling',
    subtitle: 'reality frays with each word',
    isPremium: false,
    category: 'alternate',
    path: '/room/the-unraveling',
  },
  {
    id: 'the-echo',
    title: 'The Echo',
    subtitle: 'what you say never leaves',
    isPremium: false,
    category: 'alternate',
    path: '/room/the-echo',
  },
  // NEW PHASE 1 ROOMS
  {
    id: 'letters-never-sent',
    title: 'Letters Never Sent',
    subtitle: 'Write to someone you cannot reach',
    isPremium: false,
    category: 'experimental',
    path: '/room/letters-never-sent',
  },
  {
    id: 'breath-sync',
    title: 'Breath Sync',
    subtitle: 'Synchronize with the rhythm',
    isPremium: false,
    category: 'games',
    path: '/room/breath-sync',
  },
  {
    id: 'entropy-garden',
    title: 'Entropy Garden',
    subtitle: 'Plant seeds that grow with attention',
    isPremium: false,
    category: 'games',
    path: '/room/entropy-garden',
  },
  {
    id: 'memory-palace',
    title: 'Memory Palace',
    subtitle: 'Build a mental map of meaning',
    isPremium: false,
    category: 'games',
    path: '/room/memory-palace',
  },
  // Phase 3 - Ritual Rooms
  {
    id: 'morning-ritual',
    title: 'Morning Ritual',
    subtitle: 'Begin the day with intention',
    isPremium: false,
    category: 'daily',
    path: '/room/morning-ritual',
    isTimeLocked: true,
  },
  {
    id: 'evening-ritual',
    title: 'Evening Ritual',
    subtitle: 'Wind down with reflection',
    isPremium: false,
    category: 'daily',
    path: '/room/evening-ritual',
    isTimeLocked: true,
  },
  {
    id: 'weekly-ritual',
    title: 'Weekly Ritual',
    subtitle: 'Reflect on the week that was',
    isPremium: false,
    category: 'daily',
    path: '/room/weekly-ritual',
    isTimeLocked: true,
  },
  // Phase 4 - Seasonal Rooms
  {
    id: 'spring-equinox-room',
    title: 'Spring Equinox',
    subtitle: 'Release and renew',
    isPremium: false,
    category: 'daily',
    path: '/room/spring-equinox',
  },
  {
    id: 'summer-solstice-room',
    title: 'Summer Solstice',
    subtitle: 'The longest day',
    isPremium: false,
    category: 'daily',
    path: '/room/summer-solstice',
  },
  {
    id: 'autumn-equinox-room',
    title: 'Autumn Equinox',
    subtitle: 'Harvest and accept',
    isPremium: false,
    category: 'daily',
    path: '/room/autumn-equinox',
  },
  {
    id: 'valentine-room',
    title: 'Self-Love Room',
    subtitle: 'The love you deserve',
    isPremium: false,
    category: 'daily',
    path: '/room/valentine',
  },
  // FRAGMENT TRADING ROOM
  {
    id: 'fragment-trade',
    title: 'The Fragment Altar',
    subtitle: 'Sacrifice to unlock secrets',
    isPremium: false,
    category: 'secret',
    path: '/room/fragment-trade',
  },
  // Phase 6 - Theme-Exclusive Rooms
  {
    id: 'eclipse-shadows',
    title: 'Eclipse Shadows',
    subtitle: 'Speak into the total darkness',
    isPremium: false,
    category: 'experimental',
    path: '/room/eclipse-shadows',
  },
  {
    id: 'dawn-awakening',
    title: 'Dawn Awakening',
    subtitle: 'Greet the first light',
    isPremium: false,
    category: 'experimental',
    path: '/room/dawn-awakening',
    isTimeLocked: true,
  },
  // Phase 8 - Anniversary & Milestone Rooms
  {
    id: 'the-archive',
    title: 'The Archive',
    subtitle: 'Your complete journey history',
    isPremium: false,
    category: 'meta',
    path: '/room/the-archive',
  },
  {
    id: 'mirror-of-all-selves',
    title: 'Mirror of All Selves',
    subtitle: 'AI reveals your behavioral portrait',
    isPremium: false,
    category: 'experimental',
    path: '/room/mirror-of-all-selves',
  },
  {
    id: 'the-ending',
    title: 'The Ending',
    subtitle: 'A farewell you earned',
    isPremium: false,
    category: 'experimental',
    path: '/room/the-ending',
  },
  // Phase 11: Social Whispers & Shared Moments
  {
    id: 'whisper-wall',
    title: 'The Whisper Wall',
    subtitle: 'Anonymous truths float in the dark',
    isPremium: false,
    category: 'experimental',
    path: '/room/whisper-wall',
  },
  {
    id: 'collective-memory',
    title: 'Collective Memory',
    subtitle: 'Shared fragments of what we remember',
    isPremium: false,
    category: 'experimental',
    path: '/room/collective-memory',
  },
  {
    id: 'shared-moments',
    title: 'Shared Moments',
    subtitle: 'How are you, honestly?',
    isPremium: false,
    category: 'experimental',
    path: '/room/shared-moments',
  },
  // v3.21.0 - Identity & Truth Rooms
  { id: 'mask-you-wear', title: 'The Mask You Wear', subtitle: 'What face do you show?', isPremium: false, category: 'identity', path: '/room/mask-you-wear' },
  { id: 'recurring-dream', title: 'Your Recurring Dream', subtitle: 'The dream that keeps coming back', isPremium: false, category: 'identity', path: '/room/recurring-dream' },
  { id: 'promise-you-broke', title: 'The Promise You Broke', subtitle: 'Honesty about broken promises', isPremium: false, category: 'truth', path: '/room/promise-you-broke' },
  { id: 'words-you-swallowed', title: 'Words You Swallowed', subtitle: 'Things you never said', isPremium: false, category: 'identity', path: '/room/words-you-swallowed' },
  { id: 'age-you-feel', title: 'The Age You Feel', subtitle: 'How old are you really?', isPremium: false, category: 'identity', path: '/room/age-you-feel' },
  { id: 'biggest-lie', title: 'Your Biggest Lie', subtitle: 'The lie you tell most', isPremium: false, category: 'truth', path: '/room/biggest-lie' },
  { id: 'person-you-pretend', title: 'The Person You Pretend To Be', subtitle: 'Your performance', isPremium: false, category: 'identity', path: '/room/person-you-pretend' },
  { id: 'what-you-collect', title: 'What You Collect', subtitle: 'Objects reveal identity', isPremium: false, category: 'identity', path: '/room/what-you-collect' },
  { id: 'apology-you-owe', title: 'The Apology You Owe', subtitle: 'Write what you should have said', isPremium: false, category: 'truth', path: '/room/apology-you-owe' },
  { id: 'unfinished-story', title: 'Your Unfinished Story', subtitle: 'The thing you never completed', isPremium: false, category: 'identity', path: '/room/unfinished-story' },
  { id: 'version-others-see', title: 'The Version Others See', subtitle: 'How others perceive you', isPremium: false, category: 'identity', path: '/room/version-others-see' },
  { id: 'secret-talent', title: 'Your Secret Talent', subtitle: 'What no one knows you can do', isPremium: false, category: 'identity', path: '/room/secret-talent' },
  { id: 'fear-you-feed', title: 'The Fear You Feed', subtitle: 'Which fear controls you?', isPremium: false, category: 'truth', path: '/room/fear-you-feed' },
  { id: 'guilty-pleasure', title: 'Your Guilty Pleasure', subtitle: 'What you hide enjoying', isPremium: false, category: 'identity', path: '/room/guilty-pleasure' },
  { id: 'rule-you-break', title: 'The Rule You Always Break', subtitle: 'Your pattern of rebellion', isPremium: false, category: 'truth', path: '/room/rule-you-break' },
  { id: 'childhood-promise', title: 'Your Childhood Promise', subtitle: 'What you promised yourself', isPremium: false, category: 'identity', path: '/room/childhood-promise' },
  { id: 'compliment-you-reject', title: 'The Compliment You Reject', subtitle: 'Why can\'t you accept praise?', isPremium: false, category: 'identity', path: '/room/compliment-you-reject' },
  { id: 'autopilot-mode', title: 'Your Autopilot Mode', subtitle: 'What you do without thinking', isPremium: false, category: 'truth', path: '/room/autopilot-mode' },
  { id: 'boundary-you-need', title: 'The Boundary You Need', subtitle: 'What you should protect', isPremium: false, category: 'identity', path: '/room/boundary-you-need' },
  { id: 'inner-critic', title: 'Your Inner Critic', subtitle: 'The voice that judges', isPremium: false, category: 'identity', path: '/room/inner-critic' },
  // v3.21.0 - Time & Mortality Rooms
  { id: 'last-sunday', title: 'Last Sunday', subtitle: 'What did you actually do?', isPremium: false, category: 'time', path: '/room/last-sunday' },
  { id: 'wasted-hours', title: 'Your Wasted Hours', subtitle: 'Where time disappears', isPremium: false, category: 'time', path: '/room/wasted-hours' },
  { id: 'year-that-changed', title: 'The Year That Changed You', subtitle: 'The turning point', isPremium: false, category: 'time', path: '/room/year-that-changed' },
  { id: 'tomorrows-regret', title: 'Tomorrow\'s Regret', subtitle: 'What will you wish you did?', isPremium: false, category: 'time', path: '/room/tomorrows-regret' },
  { id: 'morning-autopilot', title: 'Your Morning Autopilot', subtitle: 'The first hour ritual', isPremium: false, category: 'time', path: '/room/morning-autopilot' },
  { id: 'season-you-dread', title: 'The Season You Dread', subtitle: 'Which season weighs heaviest?', isPremium: false, category: 'time', path: '/room/season-you-dread' },
  { id: 'ten-years-ago', title: 'Ten Years Ago Today', subtitle: 'Who were you then?', isPremium: false, category: 'time', path: '/room/ten-years-ago' },
  { id: 'last-normal-day', title: 'Your Last Normal Day', subtitle: 'Before everything changed', isPremium: false, category: 'time', path: '/room/last-normal-day' },
  { id: 'clock-you-ignore', title: 'The Clock You Ignore', subtitle: 'Time you pretend doesn\'t pass', isPremium: false, category: 'time', path: '/room/clock-you-ignore' },
  { id: 'your-deadline', title: 'Your Deadline', subtitle: 'What are you postponing?', isPremium: false, category: 'time', path: '/room/your-deadline' },
  // v3.21.0 - Nothing & Contemplation Rooms
  { id: 'the-pause', title: 'The Pause', subtitle: 'Just breathe for a moment', isPremium: false, category: 'nothing', path: '/room/the-pause' },
  { id: 'static-room', title: 'Static', subtitle: 'White noise and stillness', isPremium: false, category: 'nothing', path: '/room/static-room' },
  { id: 'gap-between-thoughts', title: 'The Gap Between Thoughts', subtitle: 'Find the space', isPremium: false, category: 'nothing', path: '/room/gap-between-thoughts' },
  { id: 'sit-with-discomfort', title: 'Sit With Discomfort', subtitle: 'Don\'t fix anything', isPremium: false, category: 'nothing', path: '/room/sit-with-discomfort' },
  { id: 'boring-room', title: 'The Boring Room', subtitle: 'Nothing interesting at all', isPremium: false, category: 'nothing', path: '/room/boring-room' },
  { id: 'unplug', title: 'Unplug', subtitle: 'Imagine no devices', isPremium: false, category: 'nothing', path: '/room/unplug' },
  { id: 'last-page', title: 'The Last Page', subtitle: 'The story ends here', isPremium: false, category: 'nothing', path: '/room/last-page' },
  // v3.21.0 - Meta & Behavioral Rooms
  { id: 'scrolling-pattern', title: 'Your Scrolling Pattern', subtitle: 'How you consume content', isPremium: false, category: 'truth', path: '/room/scrolling-pattern' },
  { id: 'tab-you-keep-open', title: 'The Tab You Keep Open', subtitle: 'What stays in your browser', isPremium: false, category: 'truth', path: '/room/tab-you-keep-open' },
  { id: 'digital-shadow', title: 'Your Digital Shadow', subtitle: 'Your online footprint', isPremium: false, category: 'truth', path: '/room/digital-shadow' },
  { id: 'notification-you-ignore', title: 'The Notification You Ignore', subtitle: 'What you dismiss', isPremium: false, category: 'truth', path: '/room/notification-you-ignore' },
  { id: 'typing-speed', title: 'Your Typing Speed', subtitle: 'How fast do you express?', isPremium: false, category: 'truth', path: '/room/typing-speed' },
  { id: 'link-you-almost-clicked', title: 'The Link You Almost Clicked', subtitle: 'Hesitation patterns', isPremium: false, category: 'truth', path: '/room/link-you-almost-clicked' },
  { id: 'bookmark-graveyard', title: 'Your Bookmark Graveyard', subtitle: 'Saved but never returned', isPremium: false, category: 'truth', path: '/room/bookmark-graveyard' },
  { id: 'search-you-deleted', title: 'The Search You Deleted', subtitle: 'What you looked for and erased', isPremium: false, category: 'truth', path: '/room/search-you-deleted' },
  // v3.21.0 - Experimental & Visual Rooms
  { id: 'gravity-room', title: 'Gravity Room', subtitle: 'Everything falls slowly', isPremium: false, category: 'experimental', path: '/room/gravity-room' },
  { id: 'ink-blot', title: 'Ink Blot', subtitle: 'What do you see?', isPremium: false, category: 'experimental', path: '/room/ink-blot' },
  { id: 'hallway-of-mirrors', title: 'The Hallway of Mirrors', subtitle: 'Infinite reflections', isPremium: false, category: 'experimental', path: '/room/hallway-of-mirrors' },
  { id: 'dissolving-text', title: 'Dissolving Text', subtitle: 'Words melt as you read', isPremium: false, category: 'experimental', path: '/room/dissolving-text' },
  { id: 'the-pendulum', title: 'The Pendulum', subtitle: 'Hypnotic motion', isPremium: false, category: 'experimental', path: '/room/the-pendulum' },
  { id: 'pixel-rain', title: 'Pixel Rain', subtitle: 'Digital precipitation', isPremium: false, category: 'experimental', path: '/room/pixel-rain' },
  { id: 'the-threshold', title: 'The Threshold', subtitle: 'Between here and there', isPremium: false, category: 'experimental', path: '/room/the-threshold' },
  // v3.22.0 - Relationship & Connection
  { id: 'the-friend-you-lost', title: 'The Friend You Lost', subtitle: 'Write to someone you drifted from', isPremium: false, category: 'identity', path: '/room/the-friend-you-lost' },
  { id: 'conversation-you-replay', title: 'The Conversation You Replay', subtitle: 'Recreate it from memory', isPremium: false, category: 'identity', path: '/room/conversation-you-replay' },
  { id: 'the-thank-you', title: 'The Thank You', subtitle: 'Gratitude you never expressed', isPremium: false, category: 'identity', path: '/room/the-thank-you' },
  { id: 'people-you-forgot', title: 'People You Forgot', subtitle: 'Try to remember forgotten names', isPremium: false, category: 'identity', path: '/room/people-you-forgot' },
  { id: 'the-advice-you-give', title: 'The Advice You Give', subtitle: 'Advice you give but never follow', isPremium: false, category: 'truth', path: '/room/the-advice-you-give' },
  // v3.22.0 - Perception & Reality
  { id: 'what-others-dont-know', title: "What Others Don't Know", subtitle: 'Your hidden layers', isPremium: false, category: 'identity', path: '/room/what-others-dont-know' },
  { id: 'the-lie-you-believe', title: 'The Lie You Believe', subtitle: 'A comforting untruth', isPremium: false, category: 'truth', path: '/room/the-lie-you-believe' },
  { id: 'your-shadow-self', title: 'Your Shadow Self', subtitle: 'The part you suppress', isPremium: false, category: 'identity', path: '/room/your-shadow-self' },
  { id: 'the-story-you-tell', title: 'The Story You Tell', subtitle: 'How you narrate your life', isPremium: false, category: 'identity', path: '/room/the-story-you-tell' },
  { id: 'your-safe-place', title: 'Your Safe Place', subtitle: 'Describe where you feel safe', isPremium: false, category: 'identity', path: '/room/your-safe-place' },
  // v3.22.0 - Action & Choice
  { id: 'the-risk-you-didnt-take', title: "The Risk You Didn't Take", subtitle: 'Roads not traveled', isPremium: false, category: 'truth', path: '/room/the-risk-you-didnt-take' },
  { id: 'your-last-excuse', title: 'Your Last Excuse', subtitle: 'The excuse you use most', isPremium: false, category: 'truth', path: '/room/your-last-excuse' },
  { id: 'the-habit-you-hide', title: 'The Habit You Hide', subtitle: 'Secret routines', isPremium: false, category: 'truth', path: '/room/the-habit-you-hide' },
  { id: 'what-you-postpone', title: 'What You Postpone', subtitle: 'The thing always tomorrow', isPremium: false, category: 'truth', path: '/room/what-you-postpone' },
  { id: 'the-door-you-closed', title: 'The Door You Closed', subtitle: 'Opportunities you rejected', isPremium: false, category: 'truth', path: '/room/the-door-you-closed' },
];

export const getFreeRooms = () => rooms.filter(r => r.category !== 'scary' && r.category !== 'alternate' && !r.id.startsWith('boss-') && !r.id.startsWith('secret-') && !['idle-room', 'full-moon-room', '317am-room', 'halloween-room', 'winter-solstice-room', 'new-year-room', 'spring-equinox-room', 'summer-solstice-room', 'autumn-equinox-room', 'valentine-room'].includes(r.id));
export const getDeepRooms = () => rooms.filter(r => ['sentence-you-avoid', 'if-nothing-changes', 'real-priorities', 'last-conversation', 'who-without-job', 'comfort-zone-scanner', 'say-it-once', 'listen-to-yourself', 'life-as-shapes', 'face-without-features'].includes(r.id));
export const getNightRooms = () => rooms.filter(r => r.category === 'night');
export const getTimeLockedRooms = () => rooms.filter(r => ['full-moon-room', 'weekend-room', '317am-room'].includes(r.id));
export const getSeasonalRooms = () => rooms.filter(r => ['halloween-room', 'winter-solstice-room', 'new-year-room', 'spring-equinox-room', 'summer-solstice-room', 'autumn-equinox-room', 'valentine-room'].includes(r.id));
export const getHiddenRooms = () => rooms.filter(r => ['idle-room'].includes(r.id));
export const getMetaRooms = () => rooms.filter(r => r.category === 'meta' && !r.id.startsWith('secret-'));
export const getScaryRooms = () => rooms.filter(r => r.category === 'scary' && !r.id.startsWith('boss-') && !['halloween-room'].includes(r.id));
export const getDailyRooms = () => rooms.filter(r => r.category === 'daily');
export const getBossRooms = () => rooms.filter(r => r.id.startsWith('boss-'));
export const getSecretRooms = () => rooms.filter(r => r.id.startsWith('secret-') || r.id === 'glitch-room');
export const getGameRooms = () => rooms.filter(r => r.category === 'games');
export const getExperimentalRooms = () => rooms.filter(r => r.category === 'experimental' && !['ash-embers', 'twilight-stars', 'void-abyss', 'eclipse-shadows', 'dawn-awakening'].includes(r.id));
export const getRoomById = (id: string) => rooms.find(r => r.id === id);
export const getThemeExclusiveRooms = () => rooms.filter(r => ['ash-embers', 'twilight-stars', 'void-abyss', 'eclipse-shadows', 'dawn-awakening'].includes(r.id));
export const getAlternateModeRooms = () => rooms.filter(r => r.category === 'alternate');
